export const OPEN_TRIAL_CANCELED_MODAL = 'open-trial-canceled-modal';
